import Vue from 'vue';

/* Global Components */
Vue.component('VueHeadful', () => import('vue-headful'));
